import React, { useState, useEffect } from 'react';

import PageLoader from 'ui/PageLoader';

import GroupsForm from './GroupsForm';
import { updateGroup, loadGroup, loadCompanies, loadCompany } from './services';

export default function GroupCreate({ match, history, updateBreadcrumbs }) {
    const { id, company_id: companyId } = match.params;
    const [loading, setLoading] = useState(false);
    const [group, setGroup] = useState(null);
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        loadCompany(companyId).then(company =>
            updateBreadcrumbs([
                { name: 'Companies', path: '/companies' },
                {
                    name: company.business_name,
                    path: `/companies/${companyId}`,
                },
                'Edit Company Group',
            ])
        );
        loadGroup(id, companyId).then(setGroup);
        loadCompanies(companyId).then(setCompanies);
    }, []);

    const handleSave = async data => {
        setLoading(true);
        try {
            await updateGroup(id, data, companyId);
            handleCancel();
        } finally {
            setLoading(false);
        }
    };
    const handleCancel = () =>
        history.push(`/companies/${companyId}/partner/company_groups`);
    if (!group) {
        return <PageLoader />;
    }
    return (
        <GroupsForm
            mode="edit"
            loading={loading}
            group={group}
            companies={companies}
            onSave={handleSave}
            onCancel={handleCancel}
        />
    );
}
